import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/Sidebar.css';

const Sidebar = () => {
    const { user, logout } = useAuth();
    const { theme, toggleTheme } = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isMobileOpen, setIsMobileOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const toggleMobileSidebar = () => {
        setIsMobileOpen(!isMobileOpen);
    };

    const closeMobileSidebar = () => {
        setIsMobileOpen(false);
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    return (
        <>
            {/* Mobile Menu Button */}
            <button className="mobile-menu-btn" onClick={toggleMobileSidebar}>
                ☰
            </button>

            {/* Mobile Overlay */}
            {isMobileOpen && (
                <div className="sidebar-overlay" onClick={closeMobileSidebar}></div>
            )}

            {/* Sidebar */}
            <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
                {/* Brand */}
                <div className="sidebar-brand" onClick={toggleSidebar} style={{ cursor: 'pointer' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                        <span className="brand-icon">⚡</span>
                        {!isCollapsed && <span className="brand-text">TaskFocus</span>}
                    </div>
                </div>

                {/* Navigation Links */}
                <nav className="sidebar-nav">
                    <Link 
                        to="/" 
                        className={`sidebar-link ${isActive('/') ? 'active' : ''}`}
                        onClick={closeMobileSidebar}
                        title="Focus"
                    >
                        <span className="link-icon">🎯</span>
                        {!isCollapsed && <span className="link-text">Focus</span>}
                    </Link>
                    
                    <Link 
                        to="/tasks" 
                        className={`sidebar-link ${isActive('/tasks') ? 'active' : ''}`}
                        onClick={closeMobileSidebar}
                        title="All Tasks"
                    >
                        <span className="link-icon">📋</span>
                        {!isCollapsed && <span className="link-text">All Tasks</span>}
                    </Link>
                    
                    <Link 
                        to="/groups" 
                        className={`sidebar-link ${isActive('/groups') ? 'active' : ''}`}
                        onClick={closeMobileSidebar}
                        title="Groups"
                    >
                        <span className="link-icon">📁</span>
                        {!isCollapsed && <span className="link-text">Groups</span>}
                    </Link>
                    
                    <Link 
                        to="/statistics" 
                        className={`sidebar-link ${isActive('/statistics') ? 'active' : ''}`}
                        onClick={closeMobileSidebar}
                        title="Statistics"
                    >
                        <span className="link-icon">📊</span>
                        {!isCollapsed && <span className="link-text">Statistics</span>}
                    </Link>
                    
                    <Link 
                        to="/settings" 
                        className={`sidebar-link ${isActive('/settings') ? 'active' : ''}`}
                        onClick={closeMobileSidebar}
                        title="Settings"
                    >
                        <span className="link-icon">⚙️</span>
                        {!isCollapsed && <span className="link-text">Settings</span>}
                    </Link>
                </nav>

                {/* Bottom Actions */}
                <div className="sidebar-bottom">
                    <button 
                        onClick={toggleTheme} 
                        className="sidebar-link" 
                        title={theme === 'light' ? 'Dark Mode' : 'Light Mode'}
                    >
                        <span className="link-icon">{theme === 'light' ? '🌙' : '☀️'}</span>
                        {!isCollapsed && <span className="link-text">Theme</span>}
                    </button>

                    <div className="user-section">
                        {!isCollapsed && (
                            <div className="user-info">
                                <span className="user-icon">👤</span>
                                <span className="username">{user?.username}</span>
                            </div>
                        )}
                        <button 
                            onClick={handleLogout} 
                            className="btn-logout"
                            title="Logout"
                        >
                            <span className="link-icon">🚪</span>
                            {!isCollapsed && <span className="link-text">Logout</span>}
                        </button>
                    </div>
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
